// src/App.js - Main application component with routing
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider';
import { ProtectedRoute } from './components/ProtectedRoute';
import Layout from './components/layout/Layout';
import HomePage from './pages/HomePage';
import TutorialPage from './pages/TutorialPage';
import ReferencePage from './pages/ReferencePage';
import ScenariosPage from './pages/ScenariosPage';
import ResourcesPage from './pages/ResourcesPage';
import NotFoundPage from './pages/NotFoundPage';
import LoginPage from './pages/LoginPage';

const App = () => {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={
          <ProtectedRoute>
            <Layout><HomePage /></Layout>
          </ProtectedRoute>
        } />
        <Route path="/tutorial" element={
          <ProtectedRoute>
            <Layout><TutorialPage /></Layout>
          </ProtectedRoute>
        } />
        <Route path="/reference" element={
          <ProtectedRoute>
            <Layout><ReferencePage /></Layout>
          </ProtectedRoute>
        } />
        <Route path="/learning" element={
          <ProtectedRoute>
            <Layout><ScenariosPage /></Layout>
          </ProtectedRoute>
        } />
        <Route path="/resources" element={
          <ProtectedRoute>
            <Layout><ResourcesPage /></Layout>
          </ProtectedRoute>
        } />
        <Route path="*" element={<Layout><NotFoundPage /></Layout>} />
      </Routes>
    </AuthProvider>
  );
};

export default App; 